<section class="popout-shell">
    <app-pdf-schematic-viewer [pdfUrl]="pdfUrl()" [searchQuery]="focusedDesignator()" [fullBleedMode]="true">
    </app-pdf-schematic-viewer>
</section>